import SVG from 'react-inlinesvg'
import { useContextPanels } from '../../contexts/panelsContext'
import React, { Ref } from 'react'
import { UIElement } from '../../types/UIElements'
import { useContextScreensaver } from '../../contexts/screensaverContext'
import { cn } from '../../utils/cn'

// the ref lets the side menu grow out of the button
const SideMenuButton = (props: { ref?: Ref<HTMLButtonElement> }) => {
  const { isPanelOpen, toggleSideMenu } = useContextPanels()
  const { setIsScreensaverOn } = useContextScreensaver()
  // the welcome screen is only shown on load, the button fades in once it's gone
  const isVisible = !isPanelOpen(UIElement.WELCOME)

  const handleClick = (e: React.MouseEvent) => {
    setIsScreensaverOn(false)
    toggleSideMenu()
    e.currentTarget?.classList.remove('shake')
  }

  return (
    <button
      ref={props.ref}
      onClick={e => handleClick(e)}
      className={cn(
        'shake fixed left-[10px] top-[2vh] z-20 flex size-[40px] items-center justify-center rounded-full border border-solid border-white/50 bg-black95 text-white shadow-floating [transition:0.3s_linear] focus-visible:[outline:none] tall-xxs:size-[50px] tall-xs:top-[10vh] xs:tall-sm:top-[18vh] sm:top-[10.5vh] sm:size-[70px] md:size-[80px] xl:size-[90px] xxl:left-[calc(3vw+6px)] xxl:top-[15vh] xxl:size-[112px] [&.shake]:origin-center [&.shake]:animate-[shake-horizontally_10s_2.5s_ease_infinite]',
        { 'opacity-100': isVisible, 'opacity-0': !isVisible },
      )}
    >
      <SVG
        className="absolute left-1/2 top-1/2 size-[45%] -translate-x-1/2 -translate-y-1/2"
        src="/icons/hamburger.svg"
      />
    </button>
  )
}
export default SideMenuButton
